export default "__VITE_PUBLIC_ASSET__fcefd2eb__"